export function isValidUrl(value) {
  try {
    new URL(value)
    return true
  } catch {
    return false
  }
}